var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 2.3335H4.08366L21.5837 25.6668H18.667L1.16699 2.3335ZM6.41699 2.3335H9.33366L26.8337 25.6668H23.917L6.41699 2.3335ZM3.50033 2.3335H9.33366V4.66683H3.50033V2.3335ZM18.667 23.3335H24.5003V25.6668H18.667V23.3335ZM21.5837 2.3335H25.667L5.83366 25.6668H1.75033L21.5837 2.3335Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0cd673ea7e1abb88530f67a3d37089fd.svg";
export { ForwardRef as ReactComponent };